var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundEgg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 354,
    viewBox: "0 0 480 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.212 347.505C352.786 372.578 448.845 317.51 473.766 224.506C498.686 131.503 443.031 35.7827 349.456 10.7095C255.881 -14.3637 28.0423 5.39427 3.12208 98.3978C-21.7982 191.401 165.637 322.432 259.212 347.505Z",
    fill: "#F8F8FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEgg11);
export default __webpack_public_path__ + "static/media/background-egg-11.3886fce3f001ad5ad9759206eddecd4e.svg";
export { ForwardRef as ReactComponent };